(() => {
  if (customElements.get('testimonials-carousel')) {
    return;
  }

  class TestimonialsCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
        slidesPerView: 1,
        spaceBetween: 12,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
        },
      };
      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('testimonials-carousel', TestimonialsCarousel);
})();
